// extracted by mini-css-extract-plugin
export var awesome = "styles-module--awesome--c59c7";
export var bold = "styles-module--bold--c981f";
export var center = "styles-module--center--bdc0a";
export var h1 = "styles-module--h1--adce2";
export var h1Bold = "styles-module--h1--bold--4ecb4";
export var h1Uc = "styles-module--h1--uc--8b580";
export var h2 = "styles-module--h2--c6eab";
export var h2Bold = "styles-module--h2--bold--b1698";
export var h2Uc = "styles-module--h2--uc--f03d3";
export var h3 = "styles-module--h3--9d8f3";
export var h3Bold = "styles-module--h3--bold--bab6f";
export var h3Uc = "styles-module--h3--uc--26e55";
export var h4 = "styles-module--h4--7eccb";
export var h4Bold = "styles-module--h4--bold--4c2cc";
export var h4Uc = "styles-module--h4--uc--31353";
export var linkUnderline = "styles-module--link--underline--4af2d";
export var microtext = "styles-module--microtext--f1883";
export var microtextBold = "styles-module--microtext--bold--b3b89";
export var microtextUc = "styles-module--microtext--uc--9cb31";
export var nanotext = "styles-module--nanotext--97776";
export var strikethrough = "styles-module--strikethrough--1e83c";
export var strikethroughBold = "styles-module--strikethrough--bold--ccdbb";
export var strikethroughLg = "styles-module--strikethrough--lg--9b5e1";
export var strikethroughSm = "styles-module--strikethrough--sm--ccfd9";
export var subtext = "styles-module--subtext--bbd9a";
export var subtextBold = "styles-module--subtext--bold--6c9c3";
export var subtextUc = "styles-module--subtext--uc--8923e";
export var text = "styles-module--text--43f88";
export var textBold = "styles-module--text--bold--93ad0";
export var textUc = "styles-module--text--uc--d7b85";
export var titleL = "styles-module--title-l--0d9c0";
export var titleM = "styles-module--title-m--5534a";
export var titleS = "styles-module--title-s--141ed";
export var titleXl = "styles-module--title-xl--f24f9";
export var titleXs = "styles-module--title-xs--d06d3";
export var titleXxs = "styles-module--title-xxs--8297f";
export var uc = "styles-module--uc--ef597";
export var underline = "styles-module--underline--eda2f";
export var uspBlock = "styles-module--usp-block--98fc8";
export var uspBlocks = "styles-module--usp-blocks--68043";
export var uspContainer = "styles-module--usp-container--83f7c";
export var uspIconBlock = "styles-module--usp-icon-block--e2d33";
export var uspIcons = "styles-module--usp-icons--f99a0";
export var uspText = "styles-module--usp-text--7afe5";
export var uspTitle = "styles-module--usp-title--b6f75";